<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500"
      >
        RSA Services
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        small
        @click="openDialog()"
        v-if="checkPermission('app_service_type:rsa_service_types')"
        >Add Service</v-btn
      >
      <!-- -->
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="serviceList"
      :options.sync="options"
      :server-items-length="total"
      :loading="serviceListLoader"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-form
          @submit.prevent="searchAll"
          @keydown.enter.prevent
          type="submit"
        >
          <v-row class="custom-row pl-5 pr-5">
            <v-col cols="12" sm="3">
              <v-text-field
                label="Service Name"
                v-model="service_name"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                label="Service code"
                v-model="service_code"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="delivery_type"
                :items="deliveryTypes"
                outlined
                dense
                chips
                item-text="text"
                item-value="value"
                small-chips
                label="Delivery Type"
                multiple
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="status"
                :items="statuses"
                outlined
                item-text="text"
                item-value="value"
                small-chips
                label="Status"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="text-end pr-4 mb-2">
              <v-btn
                class="success"
                color="primary"
                @click="searchAll"
                type="submit"
                >Search</v-btn
              >
              <v-btn color="white" class="ml-4" @click="allClear">Clear</v-btn>
            </v-col>
          </v-row>
          <v-divider class="mb-2 mt-2"></v-divider>
        </v-form>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_service_type:specific_rsa_service_type_list')
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="edit(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span :class="item.status == 1 ? 'badge-active' : 'badge'">
          {{ item.status == 1 ? "Active" : "In-active" }}
        </span>
      </template>
      <template v-slot:[`item.delivery_type`]="{ item }">
        {{ capitalizeFirstLetter(item.delivery_type) }}
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    is_add_edit: false,
    editMode: false,
    dialog: false,
    deliveryTypes: [
      { text: "Crossborder", value: "crossborder" },
      { text: "Domestic", value: "domestic" },
    ],
    statuses: [
      { text: "Active", value: 1 },
      { text: "In-active", value: 0 },
    ],
    editedItem: {
      service_code: null,
      service_name: null,
      status: null,
      delivery_type: [],
    },
    service_code: null,
    service_name: null,
    status: null,
    delivery_type: [],
    headers: [
      {
        text: "Service Name",
        value: "service_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Service Code",
        value: "service_code",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Delivery Type",
        value: "delivery_type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Description",
        value: "service_description",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    options: {},
    total: 0,
    serviceListLoader: false,
    filtersArr: [],
    serviceList: [],
    carrier: null,
    downloader: false,
  }),

  watch: {
    options: {
      handler() {
        this.fetchServiceList();
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    ...mapActions([
      "getRSAServiceList",
      "snackBar",
      "addRSAService",
      "getService",
      "updateService",
    ]),
    openDialog() {
      this.$router.push({
        name: "AddRsaServices",
        params: { id: 0 },
      });
    },
    edit(item) {
      this.$router.push({
        name: "AddRsaServices",
        params: { id: item.id },
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let obj = {
        service_name: this.editedItem.service_name,
        service_code: this.editedItem.service_code,
        status: this.editedItem.status,
        delivery_type: this.editedItem.delivery_type.join(","),
      };
      if (this.editMode == false) {
        this.addRSAService(obj).then((result) => {
          this.snackBar({
            color: "success",
            message: result.data.message,
          });
          this.dialog = false;
          this.$refs.form.reset();
          this.fetchServiceList();
        });
      } else {
        (this.editedItem.delivery_type =
          this.editedItem.delivery_type.join(",")),
          delete this.editedItem.service_description;
        this.updateService(this.editedItem).then((result) => {
          this.snackBar({
            color: "success",
            message: result.data.message,
          });
          this.dialog = false;
          this.$refs.form.reset();
          this.fetchServiceList();
        });
      }
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
      this.editMode = false;
    },
    allFilters() {
      this.loader = true;
      let obj = {
        delivery_type: this.delivery_type.join(","),
        service_name: this.service_name,
        service_code: this.service_code,
        status: this.status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getRSAServiceList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.serviceListLoader = false;
          this.serviceList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    clear() {
      this.service_code = null;
      this.service_name = null;
      this.status = null;
      this.delivery_type = [];
    },
    async allClear() {
      await this.clear();
      this.filtersArr = {};
      await this.fetchServiceList();
    },

    fetchServiceList() {
      this.serviceList = [];
      this.serviceListLoader = true;
      this.getRSAServiceList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.serviceListLoader = false;
          this.serviceList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.serviceListLoader = false;
        });
    },
  },
};
</script>
<style scoped>
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
